import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=a0eb470c&scoped=true"
var script = {}
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=a0eb470c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb470c",
  null
  
)

export default component.exports